@if (themeService.style) {
  <div
  [innerHTML]="themeService.style | useStyle"></div>
}
